import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'
import 'firebase/storage'

const options = {
  apiKey: 'AIzaSyCbgw7UacHrXRbQUl2sUUYJBuYJc0jXu3o',
  authDomain: 'ultracarebr.firebaseapp.com',
  databaseURL: 'https://ultracarebr.firebaseio.com',
  projectId: 'ultracarebr',
  storageBucket: 'ultracarebr.appspot.com',
  messagingSenderId: '197582994272'
}
const firebaseApp = firebase.initializeApp(options)
const secondApp = firebase.initializeApp(options, 'second')

export const core = firebase

export const auth = firebaseApp.auth()
export const authSecond = secondApp.auth()

export const db = firebaseApp.firestore()

export const storage = firebaseApp.storage()

export const storageReports = firebaseApp.storage('gs://ultracarebr-reports')
// export const storageImages = firebaseApp.storage('gs://ultrabebe-bucket-files')
export const storageImages = firebaseApp.storage('gs://ultracarebr-images-upload')

export const uploadImage = (file, filename, cnpj) => {
  return new Promise((resolve, reject) => {
    if (!file || !filename || !cnpj) return resolve(null)
    const path = `${cnpj}/${filename}`
    const uploadTask = storageImages.ref().child(path).put(file)
    console.log('filename: ', filename)
    uploadTask.on('state_changed', (snapshot) => {
      const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100
      console.log(progress)
    }, error => {
      reject(error)
    }, () => {
      uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
        resolve(downloadURL)
      })
    })
  })
}



// WEBPACK FOOTER //
// ./src/store/firebase.js